import EditComponent from './MerchantEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import { Switch } from 'antd';

//组件 
const WebComponent = (props: any) => {

    /** api服务id */
    const apiId = 'merchant';

    //表头
    const columnsHead = [
        {
            title: '商户名',
            dataIndex: 'merchantName'
        },
        {
            title: '公司',
            dataIndex: 'company',
            render: (text: any) => text?.companyName
        },
        {
            title: '联系人',
            dataIndex: 'contacts'
        },
        {
            title: '联系电话',
            dataIndex: 'contactNumber'
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => {
                return (
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                    />
                )
            }
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '商户',
        apiId,
        columns,
        showStates: true,
        EditComponent
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponent;
